import React from 'react';
import { Box, Icon, Typography } from '@material-ui/core';

import useStyles from './styles';

const Locked = () => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box className="locked-title">
        <Icon className="locked-title-icon">lock</Icon>
        <Typography className="locked-title-text" variant="subtitle1">
          Certificado bloqueado
        </Typography>
      </Box>
      <Typography className="locked-description" variant="body2">
        O certificado de conclusão do curso ainda não está liberado.
      </Typography>
    </Box>
  );
};

export default Locked;
